const TONES = {
  neutral: 'pill-neutral',
  dark: 'pill-dark',
  accent: 'pill-accent',
  success: 'pill-success',
  warning: 'pill-warning',
  danger: 'pill-danger',
};

export default function Pill({ tone = 'neutral', icon, children, title }) {
  return (
    <span className={`pill ${TONES[tone] || TONES.neutral}`} title={title}>
      {icon && <i className={`bi ${icon}`} aria-hidden="true" />}
      {children}
    </span>
  );
}
